export default __webpack_public_path__ + "static/media/head-panda.7ab05247.png";